import Mock from 'mockjs'

const List = []
const ListTemp = []
const count = 100

const baseContent = '<p>I am testing data, I am testing data.</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>'
const image_uri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3'

for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: '@increment(1)', // id
    lasttm: +Mock.Random.date('T'), // 上传时间
    savetm: +Mock.Random.date('T'), // 入库时间
    lastuser: '@first', // 上传人
    reviewer: '@first',
    // locality: '@integer(2000, 2020)年',//管理单位
    username: '@first', // 用户姓名
    pwd: '123456',
    gropname: '@first', // 分组名
    'locality|1': ['水利部', '长江委水位'], // 管理单位
    'instcd|1': ['0', '1'], // /管理单位
    memo: '@integer(2000, 2020)年', // 备注
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'usertype|1': ['0', '1'], // 文件状态
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}

for (let i = 0; i < count; i++) {
  ListTemp.push(Mock.mock({
    id: '@increment(1)', // id
    lasttm: +Mock.Random.date('T'), // 上传时间
    savetm: +Mock.Random.date('T'), // 入库时间
    lastuser: '@first', // 上传人
    reviewer: '@first',
    // locality: '@integer(2000, 2020)年',//管理单位
    stnm: '@first', // 测站名称
    stcd: '@integer(10000000, 99999999)1', // 测站编码
    stcd5: '@integer(10000, 99999)1', // 测站编码
    shuiwei: '@integer(10, 999)1', // 测站编码
    liuliang: '@integer(100, 99999)1', // 测站编码
    jiangyu: '@integer(1, 999)1', // 测站编码
    'locality|1': ['水利部', '长江委水位'], // 管理单位
    'instcd|1': ['0', '1'], // /管理单位
    memo: '@integer(2000, 2020)年', // 备注
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'usertype|1': ['0', '1', '2'], // 文件状态
    'mid|1': ['11', '12', '13', '14', '15', '16', '16', '17', '18', '21', '22', '23'], // 文件状态
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}

export default [
  {
    url: '/vue-element-admin/Unit/GetUserList',
    type: 'get',
    response: config => {
      const { instcd, usertype, username, page = 1, limit = 20, sort } = config.query

      const mockList = List.filter(item => {
        if (instcd && item.instcd !== instcd) return false
        if (usertype && item.usertype !== usertype) return false
        if (username && item.username.indexOf(username) < 0) return false
        return true
      })

      // if (sort === '-id') {
      //   mockList = mockList.reverse()
      // }

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        // data: {
        //   total: mockList.length,
        //   items: pageList
        // }
        data: pageList,
        total: mockList.length
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/AddUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },

  {
    url: '/vue-element-admin/Unit/UpdateUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/DeleteUserList',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/GetStcdList',
    type: 'get',
    response: config => {
      const { markid, instcd, stnm, stcd, page = 1, limit = 20, sort } = config.query

      let mockList = ListTemp.filter(item => {
        // if (importance && item.importance !== +importance) return false
        if (markid) {
          if (markid === '1') {
            if (['11', '12', '13', '14', '15', '16', '16', '17', '18'].indexOf(item.mid) < 0) return false
          } else if (markid === '2') {
            if (['21', '22', '23'].indexOf(item.mid) < 0) return false
          } else if (item.mid !== markid) { return false }
        }
        if (instcd && item.instcd !== instcd) return false
        if (stnm && item.stnm.indexOf(stnm) < 0) return false
        if (stcd && item.stcd.indexOf(stcd) < 0) return false
        return true
      })

      if (sort === '-id') {
        mockList = mockList.reverse()
      }

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        // data: {
        //   total: mockList.length,
        //   items: pageList
        // }
        data: pageList,
        total: mockList.length
      }
    }
  },

  {
    url: '/vue-element-admin/strprp/detail',
    type: 'get',
    response: config => {
      const { id } = config.query
      for (const article of List) {
        if (article.id === +id) {
          return {
            code: 20000,
            data: article
          }
        }
      }
    }
  },

  {
    url: '/vue-element-admin/Unit/getMarkDataList',
    type: 'get',
    response: _ => {
      return {
        code: 20000,
        data: [{
          id: 1,
          label: '默认控制中心',
          children: [{
            id: 11,
            label: '管理中心'
          },
          {
            id: 12,
            label: '水情中心'
          }, {
            id: 13,
            label: '分中心3'
          }
          ]
        }]
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/AddStcd',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/UpdateStcd',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Unit/DeleteStcdList',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  }
]

